import ResetPassword from '@/components/auth/reset-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: search.token as string | undefined,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <ResetPassword />;
}
